<template>
  <!-- 약관 동의 화면 -->
  <Terms v-if="currentStep === 1" @login="goToLoginPage" @next="goToNextStep" />

  <!-- 정보 입력 화면 -->
  <RegisterForm
    v-else-if="currentStep === 2"
    @back="goToPreviousStep"
    @next="goToNextStep"
  />

  <!-- 가입 완료 화면 -->
  <RegisterComplete v-else-if="currentStep === 3" @login="goToLoginPage" />
</template>

<script setup>
import Terms from "../../components/join/Term.vue";
import RegisterForm from "../../components/join/RegisterForm.vue";
import RegisterComplete from "../../components/join/RegisterComplete.vue";
import { useRouter } from "vue-router";
import { ref } from "vue";

const router = useRouter();

// 현재 단계
const currentStep = ref(1);

// 단계 이동 함수
const goToNextStep = () => {
  if (currentStep.value < 3) {
    currentStep.value++;
  }
};

const goToPreviousStep = () => {
  if (currentStep.value > 1) {
    currentStep.value--;
  }
};

const goToLoginPage = () => {
  router.push("/");
};
</script>
